import type { ReactNode } from "react";
import { Checkbox as AriaCheckbox, type CheckboxProps as AriaCheckboxProps } from "react-aria-components";
import { cx } from "../cx.js";
import styles from "./Checkbox.module.css";

export interface CheckboxProps extends Omit<AriaCheckboxProps, "className" | "children"> {
  children: ReactNode;
  /** Karten-Optik für wichtige Bestätigungen (Einwilligung, Abgleich) */
  card?: boolean;
  className?: string;
}

export function Checkbox({ children, card, className, ...rest }: CheckboxProps) {
  return (
    <AriaCheckbox {...rest} className={cx(styles.checkbox, card && styles.card, className)}>
      <span className={styles.box} aria-hidden="true">
        <svg viewBox="0 0 16 16" className={styles.check}>
          <path d="M3.5 8.5l3 3 6-6" />
        </svg>
      </span>
      <span className={styles.text}>{children}</span>
    </AriaCheckbox>
  );
}
